<style lang="scss">
@import '~scss/_variables';

#landing {
    padding: 0 ($grid-size * 4);

    .container {
        max-width: $grid-size * 32;
        margin: ($grid-size * 4) auto 0 auto;
        position: relative;
        text-align: left;
    }

        .head {
            max-width: 47em;
        }

            .logo {
                width: 100%;
            }

            .content {
                display: inline-block;
                width: 32%;
                margin-top: $grid-size;
                margin-left: 31.8%;

                line-height: $line-height-1;
                color: $color-text-1;

                p {
                    margin-bottom: 24px;
                }
            }

        .vehicle-outlines {
            display: flex;
            justify-content: flex-end;

            width: 100%;
            height: 340px;
            max-height: 35vh;
            padding-left: $grid-size * 12;
            position: absolute;
                bottom: $grid-size;
                right: 0;

            .vehicle-illustration {
                flex: 1 0 auto;
            }
        }

        .button-container {
            margin: ($grid-size * 2) 0;
            margin-left: $grid-size * 4;
            font-size: 32px;
            text-align: left;

            button {
                width: 6em;
                height: 6em;
                font-family: $font-family-2;
                font-weight: bold;
                color: $color-white;
            }
        }
} // #landing

@include media-smaller('lg') {
    #landing {
        padding: 0 ($grid-size * 2);

        .head {
            max-width: 42em;
        }

            .content {
                width: 46%;
                margin-left: 17.8%;
            }

        .vehicle-outlines {
            height: $grid-size * 5;
            padding-left: $grid-size * 7;
        }

        .button-container {
            font-size: 24px;
            margin-left: $grid-size * 2;
        }
    }
}

@include media-smaller('md') {
    #landing {
        padding: 0 $mobile-pad;

        .container {
            margin-top: $grid-size * 2;
        }

            .head {
                display: flex;
                flex-flow: column nowrap;
                align-items: center;
                text-align: center;
            }

                .logo {
                    width: auto;
                    height: $grid-size * 2;
                }

                .content {
                    width: 100%;
                    max-width: 23em;
                    margin-left: 0;
                    text-align: center;
                }

            .vehicle-outlines {
                height: auto;
                max-height: 50vh;
                position: static;
                margin: ($grid-size * 2) 0;
                padding: 0;
            }

            .button-container {
                margin: 40px 0;
                text-align: center;
            }
    }
}

@include media-smaller('sm') {
    #landing {
        .head {
            display: block;
            text-align: right;
        }

        .content {
            max-width: none;
            text-align: left;
        }
    }
}

@media (max-height: 1000px) {
    #landing {
        .container {
            margin-top: $grid-size * 2;
        }
    }
}
</style>

<template>
    <transition name="bounce">
        <div id="landing">
            <div class="container">
                <div class="head">
                    <img class="logo" src="../assets/img/logo.svg" alt="Mission Emission">

                    <div class="content">
                        <p class="description">Calculate how much emissions a vehicle produces on a commute. Inform yourself about the harmful effects of air pollution and raise awareness!</p>

                        <button class="btn btn-link random-example-btn" @click="viewRandomExample">View a Random Example</button>
                    </div>
                </div>

                <VehicleOutlines></VehicleOutlines>

                <div class="button-container">
                    <ButtonCircular @click.native="startJourney">
                        <span>START</span>
                    </ButtonCircular>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {
    EXAMPLE_ROUTES
} from '@/const';

import VehicleOutlines from '../components/VehicleOutlines';
import ButtonCircular from '../components/entities/ButtonCircular';

export default {
    components: {ButtonCircular, VehicleOutlines},
    methods: {
        viewRandomExample () {
            var index = Math.floor(Math.random() * EXAMPLE_ROUTES.length);

            this.$router.push({
                name: 'results',
                params: {
                    id: EXAMPLE_ROUTES[index]
                }
            });

            gtag('event', 'view', {
                'event_label': 'Random example',
                'event_category': 'journey'
            });
        },
        startJourney () {
            this.$router.push('/form');

            gtag('event', 'start', {
                'event_label': 'Start button',
                'event_category': 'journey'
            });
        }
    }
};
</script>
